import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL || "";

const TOKEN_KEY = "vrmh_admin_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY) || "",
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const publicApi = axios.create({ baseURL: API_BASE });

export const adminApi = axios.create({ baseURL: API_BASE });
adminApi.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      tokenStore.clear();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin-login")) {
        window.location.href = "/admin-login";
      }
    }
    return Promise.reject(err);
  }
);

/**
 * Submit lead to (1) backend MongoDB and (2) Google Apps Script (Sheet + Email).
 * Both are best-effort in parallel; primary source of truth is the backend.
 */
export async function submitLead(payload) {
  const backendPromise = publicApi.post("/leads", payload);

  // Apps Script call: use no-cors + text/plain to avoid preflight
  const scriptPromise = GOOGLE_SCRIPT_URL
    ? fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payload),
      }).catch((e) => {
        console.warn("Apps Script sync failed (non-blocking):", e);
        return null;
      })
    : Promise.resolve(null);

  const [backendRes] = await Promise.all([backendPromise, scriptPromise]);
  return backendRes.data;
}

export const adminService = {
  login: async (email, password) => {
    const { data } = await publicApi.post("/admin/login", { email, password });
    tokenStore.set(data.token);
    return data;
  },
  logout: () => tokenStore.clear(),
  me: () => adminApi.get("/admin/me").then((r) => r.data),
  listLeads: () => adminApi.get("/admin/leads").then((r) => r.data),
  stats: () => adminApi.get("/admin/stats").then((r) => r.data),
  updateStatus: (id, status) => adminApi.patch(`/admin/leads/${id}/status`, { status }).then((r) => r.data),
  deleteLead: (id) => adminApi.delete(`/admin/leads/${id}`).then((r) => r.data),
};
